function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * @class Oskari.mapframework.bundle.statehandler.plugin.SaveViewPlugin
 * Provides functionality to save the current state as the users My Views.
 * Adds a button to the toolbar for saving a view.
 *
 * Also binds window.onbeforeunload to saving the state for keeping the state
 * between going to other pages in the portal.
 * The server is responsible for returning the saved state as initial state if
 * the user returns to the map.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.statehandler.plugin.SaveViewPlugin',
/**
 * @method create called automatically on construction
 * @static
 * @param {String} ajaxUrl
 *      URL that is called to save the state
 */

function (ajaxUrl) {
  this.handler = null;
  this.pluginName = null;
  this._sandbox = null;
  this._ajaxUrl = ajaxUrl;
}, {
  /** @static @property __name plugin name */
  __name: 'statehandler.SaveViewPlugin',
  /**
   * @method getName
   * @return {String} plugin name
   */
  getName: function getName() {
    return this.pluginName;
  },
  /**
   * @method getHandler
   * @return
   * {Oskari.mapframework.bundle.ui.module.statehandler.StateHandlerModule}
   * reference to state handler
   */
  getHandler: function getHandler() {
    return this.handler;
  },
  /**
   * @method setHandler
   * @param
   * {Oskari.mapframework.bundle.ui.module.statehandler.StateHandlerModule}
   * reference to state handler
   */
  setHandler: function setHandler(statehandler) {
    this.handler = statehandler;
    this.pluginName = statehandler.getName() + this.__name;
  },
  /**
   * @method getState
   * @return null
   * Does nothing
   */
  getState: function getState() {},
  /**
   * @method resetState
   * Does nothing
   */
  resetState: function resetState() {},
  /**
   * @method saveState
   * Saves current or given application state to server.
   * @param {Object} view (name, description)
   * @param {Object} pState view state (optional, uses
   * handler.getCurrentState() if not given)
   */
  saveState: function saveState(view, pState) {
    var state = pState;
    var me = this;
    if (!state) {
      state = this.handler.getCurrentState();
    }
    var data = {
      currentViewId: me.handler.getCurrentViewId(),
      srs: me.getSrsFromState(state),
      uuid: Oskari.app.getUuid(),
      viewData: state
    };
    if (view) {
      data.viewName = view.name;
      data.viewDescription = view.description;
      data.isDefault = view.isDefault ? view.isDefault : false;
    }
    var builder = Oskari.eventBuilder('StateSavedEvent');
    var event = builder(data.viewName, state);

    // Create Cookie of map state save
    jQuery.cookie.json = true;
    var expiredays = 7;
    jQuery.cookie('oskaristate', data, {
      expires: expiredays
    });
    if (!view) {
      // cookie set, no need to call server
      return;
    }

    // need to serialize json data so parameters are sent correctly
    data.viewData = JSON.stringify(data.viewData);
    // save to ajaxUrl
    jQuery.ajax({
      type: 'POST',
      url: this._ajaxUrl + 'action_route=AddView',
      data: data,
      success: function success(newView) {
        me._sandbox.notifyAll(event);
        me.handler.setCurrentViewId(newView.id);
      },
      error: function error() {
        // only show error if explicitly calling save

        if (data.viewName) {
          event.setError(true);
          me._sandbox.notifyAll(event);
        }
      }
    });
  },
  getSrsFromState: function getSrsFromState(state) {
    if (Oskari.util.keyExists(state, 'mapfull.state.srs')) {
      return state.mapfull.state.srs;
    }
    return null;
  },
  // TODO: move to some util
  serializeJSON: function serializeJSON(obj) {
    var me = this;
    var t = _typeof(obj);
    if (t !== 'object' || obj === null) {
      // simple data type
      if (t === 'string') {
        obj = '"' + obj + '"';
      }
      return String(obj);
    } else {
      // FIXME use ===
      // array or object
      var json = [];
      var arr = obj && obj.constructor == Array;
      jQuery.each(obj, function (k, v) {
        t = _typeof(v);
        if (t === 'string') {
          v = '"' + v + '"';
        } else if (t === 'object' && v !== null) {
          v = me.serializeJSON(v);
        }
        json.push((arr ? '' : '"' + k + '":') + String(v));
      });
      return (arr ? '[' : '{') + String(json) + (arr ? ']' : '}');
    }
  },
  /**
   * @method startPlugin
   *
   * Interface method for the plugin protocol.
   * Binds window.onbeforeunload to saving the state.
   *
   * @param {Oskari.Sandbox} sandbox
   *          reference to application sandbox
   */
  startPlugin: function startPlugin(sandbox) {
    this._sandbox = sandbox;
    var me = this;
    jQuery(document).ready(function () {
      jQuery(window).on('beforeunload', function () {
        me.saveState();
      });
    });
  },
  /**
   * @method stopPlugin
   *
   * Interface method for the plugin protocol
   *
   * @param {Oskari.Sandbox} sandbox
   *          reference to application sandbox
   */
  stopPlugin: function stopPlugin(sandbox) {
    this._sandbox = null;
  }
}, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.mapframework.bundle.statehandler.plugin.Plugin']
});